// src/utils/id.ts

export const id = () => crypto.randomUUID().replaceAll("-", "");
